import { render, staticRenderFns } from "./SegundaVuelta.vue?vue&type=template&id=5aaf6af6&"
import script from "./SegundaVuelta.vue?vue&type=script&lang=js&"
export * from "./SegundaVuelta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports